import { render } from "./backgroundPresenter.vue?vue&type=template&id=49460268&scoped=true"
import script from "./backgroundPresenter.vue?vue&type=script&lang=js"
export * from "./backgroundPresenter.vue?vue&type=script&lang=js"

import "./backgroundPresenter.vue?vue&type=style&index=0&id=49460268&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49460268"]])

export default __exports__